// components/Menu/parts/SortButtons.jsx
//import { useState, useLayoutEffect } from "react";
import { Recycle, ArrowUpDown } from "lucide-react";
import { useMenu } from "../context/MenuContext";

import {  GoDotFill } from "react-icons/go";
/***/
const SortButtons = ({ isOpen, triBtnRef, setSortPanelOpen, triLight = false }) => {
  const {
    sortNomActive,
    sortAdresseActive,
    sortDateActive,
    onRestore,
    /*viewMode,*/
    //toggleSortDate,
    selectedPeriod,
  } = useMenu();

  /* --------------------------------------------------
     Libellé dynamique du bouton "Tri…"
  -------------------------------------------------- */
  const getTriLabel = () => {
    if(triLight) return "tri par date";
    if (sortNomActive) return "tri : nom";
    if (sortAdresseActive) return "tri : rue";
    if (sortDateActive) return "tri : date";
    return "trier…";
  };

  const clickTri = () => {
    //toggleSortDate();
    setSortPanelOpen((v) => !v);
  };
  /* --------------------------------------------------
     Render
  -------------------------------------------------- */
  return (
    <>
      <div
        className={`menu-sort-buttons ${isOpen ? "open" : "closed"}`}
        aria-hidden={false}
      >
        {/* Bouton Effacer — inchangé */}
        <button
          className="restore-btn"
          onClick={onRestore}
          title="Effacer recherches, filtres et tri"
          type="button"
        >
          <Recycle size={16} />
          {isOpen && <span className="sort-label">effacer</span>}
        </button>

        {/* Bouton Tri… (menu ouvert uniquement, grid only) */}
        {isOpen && /*viewMode === "grid" &&*/ (
          <button
            ref={triBtnRef}
            //className="tri-btn"
             className={`tri-btn ${selectedPeriod ? "active" : ""}`}
            type="button"
            onClick={clickTri}
            title={!triLight?"Options de tri":"tri chronologique"}
          >
            <ArrowUpDown size={16} />
            <span className="sort-label">{getTriLabel()}</span>
            {selectedPeriod && <GoDotFill size={16} /> }
          </button>
        )}
      </div>
    </>
  );
};

export default SortButtons;
